module.exports = __webpack_public_path__ + "img/zuanjie2.b2ba35da.jpg";